(() => {
  if (window.equibowlDesignReady) return;
  window.equibowlDesignReady = true;
  const setup = (root = document) => {
    root.querySelectorAll('[data-eq-details-open]').forEach(button => {
      if (button.dataset.ready) return;
      const dialog = document.getElementById(button.dataset.eqDetailsOpen);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      button.dataset.ready = 'true';
      button.hidden = false;
      button.addEventListener('click', () => { dialog.showModal(); dialog.querySelector('[data-eq-details-close]').focus(); });
      dialog.querySelector('[data-eq-details-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => button.focus({ preventScroll: true }));
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
    });
    root.querySelectorAll('[data-eq-plan-option]').forEach(select => {
      if (select.dataset.chipsReady) return;
      select.dataset.chipsReady = 'true';
      const group = document.createElement('div');
      group.className = 'eq-choice-chips';
      group.setAttribute('role', 'group');
      const label = select.parentElement.querySelector('label');
      if (label) { label.id = `${select.id}-label`; group.setAttribute('aria-labelledby', label.id); }
      const sync = () => group.querySelectorAll('button').forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.value === select.value)); });
      Array.from(select.options).forEach(option => {
        const button = document.createElement('button');
        button.type = 'button'; button.textContent = option.textContent; button.dataset.value = option.value;
        button.addEventListener('click', () => { select.value = option.value; select.dispatchEvent(new Event('change', { bubbles: true })); sync(); });
        group.appendChild(button);
      });
      select.after(group); select.hidden = true; sync();
      select.closest('form').addEventListener('change', () => queueMicrotask(sync));
      window.addEventListener('pageshow', () => queueMicrotask(sync));
      document.addEventListener('DOMContentLoaded', () => queueMicrotask(sync), { once: true });
    });
    root.querySelectorAll('[data-eq-prepaid-form] input[type="date"][required],[data-eq-prepaid-form] input[type="tel"][required]').forEach(input => {
      if (input.dataset.errorReady) return;
      input.dataset.errorReady = 'true';
      const error = document.createElement('p'); error.className = 'eq-field-error'; error.id = `${input.id}-error`; error.hidden = true;
      error.setAttribute('role', 'status'); input.after(error);
      input.setAttribute('aria-describedby', [input.getAttribute('aria-describedby'),error.id].filter(Boolean).join(' '));
      const clear = () => { if (input.validity.valid) { error.hidden = true; error.textContent = ''; input.removeAttribute('aria-invalid'); } };
      input.addEventListener('invalid', () => { error.textContent = input.validationMessage; error.hidden = false; input.setAttribute('aria-invalid', 'true'); });
      input.addEventListener('input',clear); input.addEventListener('change',clear);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
